export const REQUEST_DONATIONS = 'app/Donations/REQUEST_DONATIONS';
export const REQUEST_DONATIONS_SUCCESS = 'app/Donations/REQUEST_DONATIONS_SUCCESS';
export const REQUEST_DONATIONS_FAILURE = 'app/Donations/REQUEST_DONATIONS_FAILURE';
